export const hotel_list_get = (workerData) => {
    let workerDataTemp = workerData.data
    let response = {}
    response["success"] = workerDataTemp.success
    response["total"] = workerDataTemp.total
    response["data"] = workerDataTemp.data
    return response
}

export const userDetailsGet = (userData) => {
    let resData = {};
    let data = [];
    if (userData.data.success) {
        let userDetailsTempHash = {};
        userDetailsTempHash.user_details = {};

        let userDetailsApiResData = userData.data.data.length > 0 ? userData.data.data[0] : [];
        userDetailsTempHash.user_details.active = userDetailsApiResData.hasOwnProperty('active') && userDetailsApiResData.active ? userDetailsApiResData.active : "";
        userDetailsTempHash.user_details.contact_number = userDetailsApiResData.hasOwnProperty('contact_number') && userDetailsApiResData.contact_number ? userDetailsApiResData.contact_number : "";
        userDetailsTempHash.user_details.email = userDetailsApiResData.hasOwnProperty('email') && userDetailsApiResData.email ? userDetailsApiResData.email : "";
        userDetailsTempHash.user_details.first_name = userDetailsApiResData.hasOwnProperty('first_name') && userDetailsApiResData.first_name ? userDetailsApiResData.first_name : "";
        userDetailsTempHash.user_details.id = userDetailsApiResData.hasOwnProperty('id') && userDetailsApiResData.id ? userDetailsApiResData.id : "";
        userDetailsTempHash.user_details.last_name = userDetailsApiResData.hasOwnProperty('last_name') && userDetailsApiResData.last_name ? userDetailsApiResData.last_name : "";
        userDetailsTempHash.user_details.profile_img = userDetailsApiResData.hasOwnProperty('profile_img') && userDetailsApiResData.profile_img ? userDetailsApiResData.profile_img : {};

        data.push(userDetailsTempHash);
        resData = {
            "success": userData.data.success,
            "total": userData.data.total,
            "data": data
        }
    } else {
        resData = {
            "success": false,
            "message": 'Something went wrong'
        }
    }

    return resData;
}

export const hotelStatusUpdateApi = (data) => {
    return data.data;
}

export const hotelCreatePost = (data) => {
    return data.data;
}
export const hotelPatchApi = (data) => {
    return data.data;
}
export const adminCreatePost = (data) => {
    return data.data;
}
export const adminCreatePatch = (data) => {
    return data.data;
}
export const hotelsDeleteApi = (data) => {
    return data.data;
}
export const subscriptionListGet = (data) => {
    return data.data;
}
export const subscribApiCallFn = (data) => {
    return data.data;
}
export const versionListGet = (data) => {
    return data.data;
}
export const uploadScreenshotPost = (data) => {
    return data.data;
}
export const paymentCreatePost = (data) => {
    return data.data;
}
export const paymentCreatePatch = (data) => {
    return data.data;
}
export const creditPointGet = (data) => {
    return data.data;
}
export const paymentPriceDistributionGet = (data) => {
    return data.data;
}